export const percent = value => `${value * 100}%`;
export const px = value => `${value}px`;